import { createListenerMiddleware, isAnyOf } from '@reduxjs/toolkit'
import debounce from 'lodash.debounce'
import { TRootState, TAppDispatch } from 'store/types'
import { aiLibVideoSlice } from 'store/features/aiLibVideo/slice'
import { aiLibThunks } from 'store/features/aiLibVideo/thunks'
import { aiLibImageSlice } from 'store/features/aiLibImage/slice'
import { aiLibImageThunks } from 'store/features/aiLibImage/thunks'

const FILTER_DEBOUNCE_DELAY = 500
const FETCH_LIMIT = 20

const aiLibListenerMiddleware = createListenerMiddleware<
  TRootState,
  TAppDispatch
>()

const debouncedFetch = debounce((dispatch: TAppDispatch) => {
  dispatch(aiLibThunks.getHistory({ offset: 0, limit: FETCH_LIMIT }))
}, FILTER_DEBOUNCE_DELAY)

const debouncedImageFetch = debounce((dispatch: TAppDispatch) => {
  dispatch(aiLibImageThunks.getHistory({ offset: 0, limit: FETCH_LIMIT }))
}, FILTER_DEBOUNCE_DELAY)

aiLibListenerMiddleware.startListening({
  matcher: isAnyOf(
    aiLibVideoSlice.actions.setFilter,
    aiLibVideoSlice.actions.resetFilters
  ),
  effect: (_, listenerApi) => {
    debouncedFetch(listenerApi.dispatch)
  }
})

aiLibListenerMiddleware.startListening({
  matcher: isAnyOf(
    aiLibImageSlice.actions.setFilter,
    aiLibImageSlice.actions.resetFilters
  ),
  effect: (_, listenerApi) => {
    debouncedImageFetch(listenerApi.dispatch)
  }
})

export const aiLibMiddleware = aiLibListenerMiddleware.middleware
